/**
 * Detail-panel toggle column header: collapses every expanded master-detail row.
 * Uses the grid API so it works for both controlled and uncontrolled expand state.
 */
import React, { useCallback } from "react";
import { IconButton, Tooltip } from "@mui/material";
import UnfoldLessIcon from "@mui/icons-material/UnfoldLess";
import {
  gridDetailPanelExpandedRowIdsSelector,
  useGridApiContext,
  useGridSelector,
} from "@mui/x-data-grid-pro";
import type { GridApiPro } from "@mui/x-data-grid-pro";
import { scheduleResetRowHeightsAfterDetailCollapse } from "./ratDataGrid.util";

export function RATDataGridDetailPanelCollapseAllHeader() {
  const apiRef = useGridApiContext<GridApiPro>();
  const expandedRowIds = useGridSelector(
    apiRef,
    gridDetailPanelExpandedRowIdsSelector
  );
  const hasExpandedRows = expandedRowIds.length > 0;

  const handleCollapseAll = useCallback(
    (event: React.MouseEvent) => {
      event.stopPropagation();
      apiRef.current.setExpandedDetailPanels([]);

      scheduleResetRowHeightsAfterDetailCollapse(
        apiRef,
        () => apiRef.current.getExpandedDetailPanels().length === 0
      );
    },
    [apiRef]
  );

  return (
    <Tooltip title="Collapse all">
      {/* span keeps Tooltip working when the IconButton is disabled */}
      <span>
        <IconButton
          size="small"
          tabIndex={-1}
          disabled={!hasExpandedRows}
          aria-label="Collapse all detail panels"
          onClick={handleCollapseAll}
        >
          <UnfoldLessIcon fontSize="inherit" />
        </IconButton>
      </span>
    </Tooltip>
  );
}
